<div class="image-file-references-wrapper" ngClass="{{rowDistributionClass}}" *ngIf="validReferences.length > 0 else FilesRemoved">
    @if (shouldHideExtraFiles && !isCollapsed) {
        <div class="row-container expanded">
            <app-image-chip class="image-chip" *ngFor="let file of secondRowFileReferences" [url]="file.url" [altText]="file.title" (clicked)="openImageInNewTab(file.id)"/>
        </div>
    }
    <div class="row-container base">
        <app-image-chip class="image-chip" *ngFor="let file of firstRowFileReferences" [url]="file.url" [altText]="file.title" (clicked)="openImageInNewTab(file.id)" />
        @if (shouldHideExtraFiles && isCollapsed) {
            <app-image-chip id="more-files-chip" [displayText]="'+' + hiddenReferencesCount" altText="More files"
                (click)="toggleCollapse()" [clickable]="false" />
        }
    </div>
</div>
<ng-template #FilesRemoved>
  <app-chip
    class="no-pointer missing-files"
    [text]="'File(s) removed'"
    [type]="ChipTypeConstant.WARNING"/>
</ng-template>
